const production = true;
const byPassAdmin = true;
const local = !production;
const debugging = false;

const getEventAsDate = pOEventData => {
    return new Date(
                                        parseInt(pOEventData.year), 
                                        parseInt(pOEventData.month)-1,
                                        parseInt(pOEventData.day),
                                        parseInt(pOEventData.hour)?parseInt(pOEventData.hour):0, 
                                        parseInt(pOEventData.minutes)?parseInt(pOEventData.minutes):0);//new Date(year,month,day,hours,minutes,seconds)
    
}

const globals = {
    parameters : {
            redux_debugging:false,
            admin_menu_enabled : true,
            website:"thonon.adventiste.org",
            debugging : debugging, 
            local:local,
            production:!local,
            interval:10000,
            form_version:1
        },
    links:{
            facebook:"https://www.facebook.com/ASJThonon/"
    },
    menu : {
            home : "Accueil",
            eventsadmin : "Editer l'agenda",
            terminaladmin : "Editer la borne",
            /*chainmenu : "Chaine de prières",*/
            terminalpreview : "Aperçu de la borne",
            terminal : "Borne",
            about_us: "A propos...",
            contact: "Nous contacter",
            login:"Connexion...",
            logoff:"Déconnexion...",
            daily_worship : "Méditation du jour",
            bible_read : "Lire la Bible",
            powered_by:"Site propulsé par neuronal.bible",
            who_are_we:"Site adventiste de Thonon les bains",
            version:"v2026.06.28c"
    },
    datasync :{
        /*DATASYNC*/
        thononadvent_company_guid:"E3762EBD-DEFF-E35B-9474-EB957F2FB297",
        uNSECURED_thononadvent_company_guid:local?"3":"4",

        media_table_guid:local?"4":"1",
        bible_request_table_guid:local?"15":"150",
        contact_request_table_guid:"9917FB8C-7E86-9924-E2E9-EADADD7384D9",       
        admin_users_table_guid:"9F42C8B7-0423-16B9-EC2A-A34081D983AA",
        adv_events_table_guid : "E9C154A6-AAAF-ED09-47B1-E777260D2F64"
    },
    mailer : {
        thonon_advent_staff_mailing_list:"thononadvent@neuronal.bible",
        ne_pas_repondre_email : "ne_pas_repondre@thononadvent.com",
        signature: "Eglise Adventiste de Thonon les bains",
        bible_request_mail_subject: "Demande de Bible gratuite",
        contact_request_mail_subject: "Demande de contact depuis le site de l'Eglise de Thonon les bains",
        bible_request_mail_message:"Je voudrais recevoir une Bible gratuite",
        bible_request_mail_acknowledge_subject: "Confirmation de demande de Bible gratuite",
        bible_request_mail_acknowledge_message: "Nous avons bien reçu votre demande de Bible gratuite, vous allez la recevoir sous peu.",
        contact_request_mail_acknowledge_message: "Nous avons bien reçu votre demande de contact, nous vous répondrons sous peu."
    }
    ,
    mailsync : {
        ...(local && {url : 'http://localhost:4404'}),
        ...(production && {url : 'https://adv-mailer-service.thononadvent.com'})
    }
    
    ,
    datasync_service : {
        ...(local && {url : "http://localhost:8888/datasync-service"}),
        ...(production && {url : 'https://rest.datasync.ovh'})
    },

    share:{
        worship:{
            ...(local && {url : 'http://localhost:3000/dailyworship'}),
            ...(production && {url : 'https://thonon.adventiste.org/dailyworship'})
        }
    }

    ,
    weekly : {
        ref:"2 Chroniques 20.22",
        verse:"Au moment où l'on commençait les chants et les louanges, l'Eternel plaça une embuscade contre les Ammonites, les Moabites et les habitants de la région montagneuse de Séir qui étaient venus contre Juda, et ils furent battus."
    }
    ,
    bible_text_endpoint : {
      ...(local && {url : 'http://localhost:5001/bible-text'}),
      ...(production && {url : 'https://bible-service.lacroisadedelapriere.org/bible-text'})
  },
    bible_books_endpoint : {
        ...(local && {url : 'http://localhost:5001/bible-books'}),
        ...(production && {url : 'https://bible-service.lacroisadedelapriere.org/bible-books'})
    },
    bible_chapters_endpoint : {
        ...(local && {url : 'http://localhost:5001/bible-chapters'}),
        ...(production && {url : 'https://bible-service.lacroisadedelapriere.org/bible-chapters'})
    },  
    services :{
        /* local */
        ...(local && {
        event_media : 'http://localhost:4000/media',
    }),
        
        
        /* Webcloud Server */
        ...(production && {
        event_media : 'https://adv-events-service.thononadvent.com/media',
    }),
    }
}

/** Fields structure declaration */
const event_form = {
    "version" : globals.parameters.form_version,
    "Rows" : [{//Row-1
      "Cols" : [
        {//col-1
        "Fields" : [
          {
            "title":"date",
            "name" : "event_date",
            name_day : "day",
            name_month : "month",
            name_year : "year",
            "input_type" : "date",
            "min_length" : -1,
            "max_length" : -1,
            "required"  : true
          }],
          },
          {//Col-2
            "Fields":[
            {
            title:"heure",
            "name" : "event_time",
            name_hour:"hour",
            name_min:"minutes",
            "input_type" : "time",
            "min_length" : 3,
            "max_length" : 10,
            "required"  : false
            }
            ],
          }],
        },//End of Row-1
  
        {//Row-2
          "Cols":[
            {//Col-1
              "Fields":[
                {
                    "name" : "event_category",
                    "title" : "Type d'activité",
                    "combo_list" : ["Prédication","Activité JA","Louange","Témoignage","Sainte-Cène","Baptême","Prière", "Autre"],
                    "input_type" : "radio",
                    "min_length" : -1,
                    "max_length" : -1,
                    "required"  : true
                  }
                ]},
            ]},

        {//Row-3
          "Cols":[
            {//Col-1
              "Fields":[
                {
                    "name" : "title",
                    "title" : "Titre activité",
                    "input_type" : "text",
                    "min_length" :3,
                    "max_length" : 50,
                    "required"  : false
                  },
                  {
                    "name" : "text",
                    "title" : "Description",
                    "placeholder" : "Description de l'activité",
                    "input_type" : "memo",
                    "min_length" : -1,
                    "max_length" : -1,
                    "required"  : true
                  }
                  ]},
            ]},
        ]}

const authent_form = {
    version : "1.0",
    Rows : [{
    Cols : [{
        Fields : [
        {
        name : "e_mail_admin",
        title : "Adresse électronique de l'administrateur",
        placeholder : "Votre adresse de courriel",
        input_type : "email",
        value:"",
        min_length : 5,
        max_length : 40,
        required  : true,
        },
        {
        name : "human_captcha",
        placeholder : "Je ne suis pas un robot",
        title : "Votre message",
        input_type : "captcha",
        min_length : -1,
        max_length : -1,
        required  : false,
        }
        ]
    }]
    }]
}

export {globals, event_form, authent_form, getEventAsDate}